import { configureStore } from "@reduxjs/toolkit";

import auth, { AuthState } from "store/auth";
import config, { ConfigState } from "store/config";
import role, { RoleState } from "store/role";
import permission, { PermissionState } from "store/permission";
import user, { UserState } from "store/user";
import folder, { FolderState } from "store/folder";
import file, { FileState } from "store/file";
import status, { StatusState } from "store/status";
import workflow, { WorkflowState } from "store/workflow";
import step, { StepState } from "store/step";
import form, { FormState } from "store/form";
import formBuilder, { FormBuilderState } from "./form-builder";
import page, { PageState } from "store/page";
import template, { TemplateState } from "store/template";
import layout, { LayoutState } from "store/layout";
import pageBuilder, { PageBuilderState } from "store/page-builder";
import groupUser, { GroupUserState } from "./group-user";

export const store = configureStore({
  reducer: {
    auth,
    config,
    role,
    permission,
    user,
    groupUser,
    folder,
    file,
    status,
    workflow,
    step,
    form,
    formBuilder,
    page,
    template,
    layout,
    pageBuilder
  },
});

export interface RootState {
  auth: AuthState;
  config: ConfigState;
  role: RoleState;
  permission: PermissionState;
  user: UserState;
  groupUser: GroupUserState;
  folder: FolderState;
  file: FileState;
  status: StatusState;
  workflow: WorkflowState;
  step: StepState;
  form: FormState;
  formBuilder: FormBuilderState;
  page: PageState;
  template: TemplateState;
  layout: LayoutState;
  pageBuilder: PageBuilderState;
}
export type AppDispatch = typeof store.dispatch;

export default RootState;